jQuery.noConflict();
(function( $ ) {
    $(function() {
        if ($('.user-avatar').length > 0) {
            $.each($('.user-avatar'), function(){
                var name = $(this).attr('data-name');
                if (name == undefined || name == '') {
                    name = 'default';
                }
                var color = stringToHslColor(name, 30, 80);
                $(this).attr('style', 'background-color: '+color+';');
            });
        }

        $('body').on('click', '.copy_to_clipboard', function(e){
            e.preventDefault();
            var text = $(this).data('target');
            navigator.clipboard.writeText(text).then(function() {
            }, function(err) {
                var $temp = $("<input>");
                $("body").append($temp);
                $temp.val($(text).val()).select();
                document.execCommand("copy");
                $temp.remove();
            });
            $(this).addClass('ok');
        });

    });
})(jQuery);

function stringToHslColor(str, s, l) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    var h = hash % 360;
    return 'hsl('+h+', '+s+'%, '+l+'%)';
}
